<div class="splash-area">
  @if (imgSrc) {
    <img [src]="imgSrc">
  }

  @if (subtitle) {
    <div class="subtitle">
      {{subtitle}}
    </div>
  }
</div>

<div class="text">
  <div class="title">
    {{title}}
  </div>


  <!--  <div class="statistic">-->
  <!--    <div class="number">-->
  <!--      114-->
  <!--    </div>-->
  <!--    <div class="label">-->
  <!--      Tiles-->
  <!--    </div>-->
  <!--  </div>-->
</div>
